/**
 * Inject V2 Script
 */
const marketBrand: Record<string, string> = {
  fi: 'axolaina.fi',
  no: 'axofinans.no',
};

export const injectV2Script = (
  market: string,
  affiliateUrl?: string,
  variant?: 'main' | 'pre'
) => {
  const element = document.getElementById('axo-root');
  if (!element) return {};

  // Prevent duplicate script injection
  if (
    document.getElementById('axo-script')?.hasAttribute('data-v2-migration')
  ) {
    console.log('V2 script already injected.');
    return;
  }

  const scriptUrl = `${import.meta.env.VITE_WL_HOST_URL}/${
    marketBrand[market]
  }/loan-application${variant === 'pre' ? '/pre' : ''}/main.js`;

  const script = document.createElement('script');
  script.id = 'axo-script';
  script.src = scriptUrl;
  script.type = 'module';
  script.setAttribute('data-v2-migration', '');

  if (affiliateUrl) {
    script.setAttribute('data-has-offers-affiliate-url', affiliateUrl);
  }

  element.insertAdjacentElement('afterend', script);

  console.log('V2 script injected successfully', { market, affiliateUrl });
};
